import React from 'react'

export const PshycologicalInformation = (props:any) => {
    const { screening_information, notes, ehc_followup_notes, screening_result } = props;
    return (
        <div className="col-sm-6 px-4">
            <h4>Psychological Information</h4>
            <table className="table table-striped border-0 mt-4">
                <tbody>
                    <tr>
                        <th scope="row">Issues:</th>
                        <td colSpan={3}>{screening_information.issues.join(", ")}</td>
                    </tr>
                    <tr>
                        <th scope="row">Other Symptoms:</th>
                        <td colSpan={3}>{screening_information.symptoms}</td>
                    </tr>
                    <tr>
                        <th scope="row">Frequency Of Symptoms:</th>
                        <td>{screening_information.frequency_of_symptoms}</td>
                        <th scope="row">Length Of Concern:</th>
                        <td>{screening_result.length_of_concern}</td>
                    </tr>
                    <tr>
                        <th scope="row">Therapeutic Medication History:</th>
                        <td>{screening_information.medication_history}</td>
                        <th scope="row">Therapeutic Histroy:</th>
                        <td>{screening_information.therapeutic_histroy}</td>
                    </tr>
                    <tr>
                        <th scope="row">Types of Theraputic History:</th>
                        <td>{screening_information.types_of_theraputic_history.length > 0 ? screening_information.types_of_theraputic_history.join(", ") : null}</td>
                        <th scope="row">Urgency of Intervention:</th>
                        <td>{screening_information.urgency_of_intervention}</td>
                    </tr>
                    <tr>
                        <th scope="row">Reason Of Interest:</th>
                        <td colSpan={3}>{screening_result.reason_for_interest}</td>
                    </tr>
                    <tr>
                        <th scope="row">Current Physical Fitness:</th>
                        <td>{screening_result.current_physical_fitness}</td>
                        <th scope="row">Physical Pain:</th>
                        <td>{screening_result.physical_pain}</td>
                    </tr>
                    <tr>
                        <th scope="row">Health Problems:</th>
                        <td colSpan={3}>{screening_result.health_problems}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
